import { xlCol, xlColq } from "../../../common/constants";
export const nonMovementHeader = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'srNo',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '50px',
    xlCol,
  },
  {
    id: 1,
    header: 'LR No.\nMan. LR No',
    exportHead: 'LR Number\nManual LR No',
    field: 'FullLRNo^^ManualLRNo',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
  },
  {
    id: 2,
    header: 'Formatted\nLRNO',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
  },
  {
    id: 3,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Booking Date\nBooking Time',
    field: 'BookingDate^^BookingTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
  },
  {
    id: 4,
    header: 'Src. Br.\nDst. Br.',
    exportHead: 'Source Branch\nDestination Branch',
    field: 'BookingBranch^^DestinationBranch',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '150px',
    xlCol,
  },
  {
    id: 5,
    header: 'Sndr. Name\nSndr. No',
    exportHead: 'Sender Name\nSender No',
    field: 'Sender^^SenderContactNo',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '120px',
    xlCol,
  },
  {
    id: 6,
    header: 'Rec. Name\nRec. No',
    exportHead: 'Receiver Name\nReceiver No',
    field: 'Receiver^^ReceiverContactNo',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '120px',
    xlCol,
  },
  {
    id: 7,
    header: 'Pymt.\nType',
    exportHead: 'Payment Type',
    field: 'PaymentType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
  },
  {
    id: 8,
    header: 'Curr. City\nCurr. Branch',
    exportHead: 'Current City\nCurrent Branch',
    field: 'CurrentCity^^CurrentBranch',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '150px',
    xlCol,
  },
  {
    id: 9,
    header: 'LR Status\nSince Days',
    exportHead: 'LR Status\nSince Days',
    field: 'LastStatus^^DaysInterval',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '100px',
    xlCol,
  },
  {
    id: 10,
    header: 'Not Moved\nSince',
    exportHead: 'Not Moved Since',
    field: 'LastTransactionTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '80px',
    xlCol,
  },
  {
    id: 11,
    header: 'Booked\nBy user',
    exportHead: 'Booked By user',
    field: 'BookedByUser',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '80px',
    xlCol,
  },
  {
    id: 12,
    header: 'Units',
    exportHead: 'Units',
    field: 'NOP',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '80px',
    xlCol: xlColq,
  },
  {
    id: 13,
    header: 'Frgt.\nChrg',
    exportHead: 'Freight Charge',
    field: 'Freight',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '80px',
    xlCol: xlColq,
  },
  {
    id: 14,
    header: 'Doc.\nchrg',
    exportHead: 'Document Charge',
    field: 'DocumentCharges',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
  },
  {
    id: 15,
    header: 'Cart.\nChrg',
    exportHead: 'Cartage Charge',
    field: 'CartageAmount',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
  },
  {
    id: 16,
    header: 'Ham.\nChrg.',
    exportHead: 'Hamali Charge',
    field: 'HamaliCharges',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
  },
  {
    id: 17,
    header: 'Op.\nHam',
    exportHead: 'Operator Hamali Charge',
    field: 'OperatorHamaliChg',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
  },
  {
    id: 18,
    header: 'Val.\nChrg.',
    exportHead: 'Valuation Charge',
    field: 'Valuation',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
  },
  {
    id: 19,
    header: 'oth.\nChrg.',
    exportHead: 'Other Charge',
    field: 'OtherCharges',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
  },
  {
    id: 20,
    header: 'Bkg.\nGST.',
    exportHead: 'Booking GST',
    field: 'ServiceTaxAmount',
    isSelected: true,
    isDefault: false,
    isMandatory: false,
    minWidth: '80px',
    xlCol: xlColq,
  },
  {
    id: 21,
    header: 'Net.\nAmt.',
    exportHead: 'Net Amount',
    field: 'NetAmount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    minWidth: '80px',
    xlCol: xlColq,
  },
]
export const nonMovementFilter = [
  { header: 'State', dataKey: "stateName", xlCol },
  { header: 'City', dataKey: "cityName", xlCol },
  { header: 'Branch', dataKey: "BranchName", xlCol },
  { header: 'Payment Type', dataKey: "paymentTypeName", xlCol },
  { header: 'Report Option', dataKey: "reportOption", xlCol },
  { header: 'Crossing Transaction', dataKey: "crossingTransactions", xlCol },
  { header: 'LR Status', dataKey: "Status", xlCol },
]

export const DetailsReportHeaderExcel = [
  { header: 'S/N', field: 'srNo', headerSx: { textAlign: 'left', minWidth: "50px" } },
  { header: 'LR No.', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Man. LR No', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Date', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Time', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Src. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Dst. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Sndr. Name', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Sndr. No', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" } },
  { header: 'Rec. Name', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Rec. No', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Pymt. Type', field: 'PaymentType', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Curr. City', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Curr. Branch', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'LR Status', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Since Days', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Not Moved Since', field: 'LastTransactionTime', headerSx: { textAlign: 'left', minWidth: "80px" }, },
  { header: 'Booked By User', field: 'BookedByUser', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Units', field: 'NOP', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Frgt. Chrg', field: 'Freight', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Doc. chrg', field: 'DocumentCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Cart. Chrg', field: 'CartageAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Ham. Chrg.', field: 'HamaliCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Op. Ham', field: 'OperatorHamaliChg', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Val. Chrg.', field: 'Valuation', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'oth. Chrg.', field: 'OtherCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Bkg. GST.', field: 'ServiceTaxAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Net. Amt.', field: 'NetAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
];

export const paymentWiseSummary = [
  { header: 'S/N', exportHead: 'S/N', field: 'sNo', xlCol: xlCol },
  { header: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: xlCol },
  { header: 'LR Count', exportHead: 'LR Count', field: 'TotalLRCount', xlCol: xlColq },
  { header: 'Units', exportHead: 'Units', field: 'TotalNOP', xlCol: xlColq },
  { header: 'Freight', exportHead: 'Freight', field: 'TotalFreight', xlCol: xlColq },
  { header: 'Doc Charge', exportHead: 'Doc Chrg.', field: 'TotalDocumentCharges', xlCol: xlColq },
  { header: 'Cartage', exportHead: 'Cartage', field: 'TotalCartageAmount', xlCol: xlColq },
  { header: 'Hamali', exportHead: 'Ham', field: 'TotalHamaliCharges', xlCol: xlColq },
  { header: 'Operator Hamali', exportHead: 'Op. Ham', field: 'TotalOperatorHamaliChg', xlCol: xlColq },
  { header: 'Valuation Chg', exportHead: 'Val. Chrg', field: 'TotalValuation', xlCol: xlColq },
  { header: 'Other Chg.', exportHead: 'Other Chrg.', field: 'TotalOtherCharges', xlCol: xlColq },
  { header: 'Booking GST', exportHead: 'Bkg GST', field: 'TotalServiceTaxAmount', xlCol: xlColq },
  { header: 'Net Amt', exportHead: 'Net Amt', field: 'TotalNetAmount', xlCol: xlColq },
];
export const branchWiseSummary = [
  { header: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol },
  { header: 'Source Branch', exportHead: 'Source Branch', field: 'BookingBranch', xlCol },
  { header: 'Destination Branch', exportHead: 'Destination Branch', field: 'DestinationBranch', xlCol, },
  { header: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol, },
  { header: 'Unit', exportHead: 'Unit', field: 'NOP', xlCol: xlColq },
  { header: 'Amount', exportHead: 'Amount', field: 'NetAmount', xlCol: xlColq },
];
export const statusWiseSummary = [
  { header: 'S/N', field: 'sNo', xlCol: xlCol },
  { header: 'Source Branch', field: 'BookingBranch', xlCol: xlCol },
  { header: 'Dest. Branch', field: 'DestinationBranch', xlCol: xlCol },
  { header: 'Pymt Type', field: 'PaymentType', xlCol: xlCol },
  {
    header: 'Booked But Pending Transfer/Disp.',
    colSpan: 3,
    children: [
      { header: 'LR Count', field: 'totalLRB', xlCol: xlColq },
      { header: 'Total Units', field: 'totalUnitB', xlCol: xlColq },
      { header: 'Total Amt.', field: 'totalNetAmtB', xlCol: xlColq },
    ],
  },
  {
    header: 'Trans./Disp. But Pending Rec',
    colSpan: 3,
    children: [
      { header: 'LR Count', field: 'totalLRD', xlCol: xlColq },
      { header: 'Total Units', field: 'totalUnitD', xlCol: xlColq },
      { header: 'Total Amt.', field: 'totalNetAmtD', xlCol: xlColq },
    ],
  },
  {
    header: 'Rec. But Pend. Trans./Dispatch',
    colSpan: 3,
    children: [
      { header: 'LR Count', field: 'totalLRR', xlCol: xlColq },
      { header: 'Total Units', field: 'totalUnitR', xlCol: xlColq },
      { header: 'Total Amt.', field: 'totalNetAmtR', xlCol: xlColq },
    ],
  },
  {
    header: 'Received But Pending Delivery',
    colSpan: 3,
    children: [
      { header: 'LR Count', field: 'totalLRDR', xlCol: xlColq },
      { header: 'Total Units', field: 'totalUnitDR', xlCol: xlColq },
      { header: 'Total Amt.', field: 'totalNetAmtDR', xlCol: xlColq },
    ],
  },
]
export const DetailsReportHeaderExcelFormattedLRNO = [
  { header: 'S/N', field: 'srNo', headerSx: { textAlign: 'left', minWidth: "50px" } },
  { header: 'Formatted LRNO', field: 'FormattedLRNO', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Man. LR No', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Date', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Time', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Src. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Dst. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Sndr. Name', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Sndr. No', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" } },
  { header: 'Rec. Name', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Rec. No', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Pymt. Type', field: 'PaymentType', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Curr. City', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Curr. Branch', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'LR Status', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Since Days', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Not Moved Since', field: 'LastTransactionTime', headerSx: { textAlign: 'left', minWidth: "80px" }, },
  { header: 'Booked By User', field: 'BookedByUser', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Units', field: 'NOP', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Frgt. Chrg', field: 'Freight', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Doc. chrg', field: 'DocumentCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Cart. Chrg', field: 'CartageAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Ham. Chrg.', field: 'HamaliCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Op. Ham', field: 'OperatorHamaliChg', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Val. Chrg.', field: 'Valuation', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'oth. Chrg.', field: 'OtherCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Bkg. GST.', field: 'ServiceTaxAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Net. Amt.', field: 'NetAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
];
export const DetailsReportHeaderExcelForBoth = [
  { header: 'S/N', field: 'srNo', headerSx: { textAlign: 'left', minWidth: "50px" } },
  { header: 'LR No.', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Formatted LRNO', field: 'FormattedLRNO', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Man. LR No', field: 'FullLRNo', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Date', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Bkg. Time', field: 'BookingDateTime', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Src. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Dst. Br.', field: 'BookingBranch', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Sndr. Name', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Sndr. No', field: 'Sender', headerSx: { textAlign: 'left', minWidth: "120px" } },
  { header: 'Rec. Name', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Rec. No', field: 'Receiver', headerSx: { textAlign: 'left', minWidth: "120px" }, },
  { header: 'Pymt. Type', field: 'PaymentType', headerSx: { textAlign: 'left', minWidth: "100px" }, },
  { header: 'Curr. City', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'Curr. Branch', field: 'CurrentCity', headerSx: { textAlign: 'left', minWidth: "150px" }, },
  { header: 'LR Status', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Since Days', field: 'LastStatus', headerSx: { textAlign: 'left', minWidth: "100px" } },
  { header: 'Not Moved Since', field: 'LastTransactionTime', headerSx: { textAlign: 'left', minWidth: "80px" }, },
  { header: 'Booked By User', field: 'BookedByUser', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Units', field: 'NOP', headerSx: { textAlign: 'right', minWidth: "80px" } },
  { header: 'Frgt. Chrg', field: 'Freight', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Doc. chrg', field: 'DocumentCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Cart. Chrg', field: 'CartageAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Ham. Chrg.', field: 'HamaliCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Op. Ham', field: 'OperatorHamaliChg', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Val. Chrg.', field: 'Valuation', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'oth. Chrg.', field: 'OtherCharges', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Bkg. GST.', field: 'ServiceTaxAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
  { header: 'Net. Amt.', field: 'NetAmount', headerSx: { textAlign: 'right', minWidth: "80px" }, },
];
export const calculateTotalTableWidth = (columns) => {
  let totalWidth = 0;
  columns.forEach((column) => {
    const minCellWidth = column.pdfColSx.minCellWidth;
    totalWidth += minCellWidth;
  });

  return totalWidth;
};
export const calculateDynamicFormatLandscape = (desiredWidth) => {
  const a4LandscapeAspectRatio = 1122 / 793;

  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
  const a4LandscapeAspectRatio = 793 / 1122;

  const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

  return [desiredWidth, dynamicHeight];
};